import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getListFoodById } from '../../selectors/order'
import { calcMoneyFood, calcPriceSale, reMapBeilage, roundMoney } from '../../utils'
import useDidMountEffect from '../../hooks/useDidMountEffect'

import FoodInCartModalComp from '../../components/food/in-cart'
import { setViewFoodDetails } from '../../actions/orderActions'
import { ensureArray } from '../../utils/helper'

const FoodInCartModal = ({ foodIds, handleClose, ...rest }) => {
    const show = foodIds?.length
    const foods = useSelector(getListFoodById(foodIds, true, 'plu'))

    const dispatch = useDispatch()

    const handleEditFood = food => {
        handleClose()

        let foodData
        if (!food) {
            foodData = null
        } else {
            const { indexInCart, foodDetails, ...rest } = food
            foodData = {
                index: indexInCart,
                ...foodDetails,
                formData: rest,
            }
        }

        dispatch(setViewFoodDetails(foodData))
    }

    useDidMountEffect(() => {
        !foods.length && handleClose()
    }, [foods.length])

    return (
        <FoodInCartModalComp
            {...rest}
            handleClose={handleClose}
            handleEditFood={handleEditFood}
            show={show}
            foods={foods.map(f => {
                const { amount, foodDetails, indexInCart, submitted } = f
                let beilageMapped = [],
                    total = 0
                if (submitted) {
                    beilageMapped = ensureArray(f.additionFoods).map(el => ({
                        name_food: el.name,
                    }))
                    total = roundMoney(
                        calcPriceSale(f.price, f.saleOffPercent || 0) * f.amount
                    ).toFixed(2)
                } else {
                    beilageMapped = reMapBeilage(f)
                    total = calcMoneyFood(f).total
                }

                return {
                    ...foodDetails,
                    currentAmount: amount,
                    exitsInCart: true,
                    updateAble: true,
                    indexInCart,
                    beilageMapped,
                    total,
                    foodData: f,
                    editable: !submitted,
                    // more beilage
                }
            })}
        />
    )
}

export default FoodInCartModal
